import React from 'react';
import { useTranslation } from 'react-i18next';
import type { IconProps } from '@oneaudi/unified-web-components';
import { Layout, Icon, Text } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';

export interface SpecsTitleProps {
  iconName: IconProps['name'];
  specId: string;
}

const SpecsTitle: React.FC<SpecsTitleProps> = ({ iconName, specId }) => {
  const { t } = useTranslation();

  return (
    <Layout data-testid="layout" direction="row" columnGap={SYS_SPACE_FIXED_100} align="center">
      <Icon size="xs" name={iconName} />
      <Text
        variant={{
          order: '1',
          style: 'bold',
        }}
        data-testid={`${specId}-title`}
      >
        {t(`featuresAndSpecsSection.categories.nonAudiOverview.specs.${specId}`)}
      </Text>
    </Layout>
  );
};

export default SpecsTitle;
